module.exports = __webpack_public_path__ + "media/images/icons/flags/HU-a56dd06eb67d31b1cd6ecfb5b2bf350f.svg";